import { useGetTodosQuery, useDeleteTodoMutation, useUpdateTodoMutation, useCompleteTodoMutation } from "./todoApiSlice"
import { memo } from 'react'
import { useState } from "react"

import { useNavigate } from 'react-router-dom'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan, faSave, faPenToSquare, faCircle, faCircleCheck } from '@fortawesome/free-solid-svg-icons'


const Todo = ({ todoId, isMobile, isAdmin }) => {

	const navigate = useNavigate()

	const { todo } = useGetTodosQuery("todoList", {
		selectFromResult: ({ data }) => ({
			todo: data?.entities[todoId]
		}),
	})

	const [completed, setCompleted] = useState(todo.completed)
	const [title, setTitle] = useState(todo.title)

	const due_date = todo.duedate;
	const [duedate, setDuedate] = useState(due_date)

	const [id] = useState(todo.id)

	const [user] = useState(todo.user)

	const onCompletedChanged = () => {
		setCompleted(prev => !prev)
	}
	const onTitleChanged = e => setTitle(e.target.value)
	const onDuedateChanged = e => setDuedate(e.target.value)

	const handleEdit = () => navigate(`/dash/todos/${id}`)

	const handleComplete = async () =>{
		if (completed===true) {
			await completeTodo({ id: id, completed: false})
			setCompleted(false)
		} else {
			await completeTodo({ id: id, completed: true})
			setCompleted(true)
		}
	}

	const [deleteTodo] = useDeleteTodoMutation()
	const [updateTodo] = useUpdateTodoMutation()
	const [completeTodo] = useCompleteTodoMutation()


	if (todo) {

		if (isMobile) {

			let iconComplete = faCircle
			if (completed) {
				iconComplete = faCircleCheck
			}

			let showTitle=null
			if (title.length > 25) {
				showTitle = title.substr(0,25) + '.....'
			} else { 
				showTitle=title
			}

			return (
				<tr>				
					<td>
						<span
							role="button"
							className="p-2 text-steel icon"
							title="Edit"
							onClick={handleEdit}
						>
							<FontAwesomeIcon icon={faPenToSquare} className="fa-icon mt-1" />
						</span>
						<span
							role="button"
							className="p-2 text-primary icon"
							title="Completed?"
							onClick={handleComplete}
						>
							<FontAwesomeIcon icon={iconComplete} className="fa-icon mt-1" />
						</span>
						<span style={{ textDecoration: completed ? 'line-through' : 'none' }}>
							{showTitle}
						</span>
					</td>
				</tr>
			)

		} else {

			let showUser=null
			if (isAdmin) {
				showUser=(
					<td style={{ width: '15%' }}>
						<div className="table-input">{todo.username}</div>
					</td>
				)
			}

			return (
				<tr>
					<td style={{ width: '10%' }}>
						<input type="checkbox" id="completed" name="completed" className="table-input" checked={completed} onChange={onCompletedChanged} style={{ marginTop: '10px' }} />
					</td>
					<td style={{ width: '45%' }}>
						<input type="text" id="title" name="title" className="table-input"
							value={title}
							onChange={onTitleChanged}
							style={{ textDecoration: completed ? 'line-through' : 'none', width: "400px" }}
						/>
					</td>
					<td style={{ width: '10%' }}>
						<input type="date" id="duedate" name="duedate" className="table-input" value={duedate} onChange={onDuedateChanged} />
					</td>
					{showUser}
					<td style={{ width: '20%' }}>
						<div className="table-input">
							<span
								role="button"
								className="p-2 text-success icon"
								title="Update"
								onClick={() => updateTodo({ id: id, title: title, completed: completed, duedate: duedate, user: user})}
							>
								<FontAwesomeIcon icon={faSave} className="fa-icon mt-1" />
							</span>
							<span
								role="button"
								className="p-2 text-danger icon"
								title="Delete"
								onClick={() => deleteTodo({ id: id })}
							>
								<FontAwesomeIcon icon={faTrashCan} className="fa-icon mt-1" />
							</span>
						</div>
					</td>
				</tr>
			)			
		
		}

	} else return null



}

const memoizedNote = memo(Todo)

export default memoizedNote